<script>
export default {
  props: {
    init: {
      default: () => false,
    },
  },

  data() {
    return {
      activeState: this.active,
    }
  },

  computed: {
    style() {
      return {
        icon: this.activeState ? 'mdi-chevron-up' : 'mdi-chevron-down',
      }
    },
  },

  methods: {
    toggleActive() {
      this.activeState = !this.activeState
    },
    activate() {
      this.activeState = true
    },
    hide() {
      this.activeState = false
    },
  },

  render(h) {
    return this.$scopedSlots.default({
      style: this.style,
      activeState: this.activeState,
      toggleActive: this.toggleActive,
      hide: this.hide,
      activate: this.activate,
    })
  },
}
</script>
